import React, { useEffect, useRef, useState } from 'react';
import { ChartOptions, ChartData, Chart } from 'chart.js';
import { Chart as ChartJS } from 'react-chartjs-2';
import { Modal, Button, Form } from 'react-bootstrap';

import { FiltroSopSales, RepositorioSopSales } from '../../core/repositories/sopSalesRepositorio';
import { formatarDecimal, formatarPorcentagem, formatLargeNumber } from '../../core/utils/funcoes';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import { useAutenticação } from '../../core/contexts/auth';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import ModalEditForecastValue from './ModalEditForecastValue';
import { ModeloSopSales } from '../../core/models/sopSales';
import moment from 'moment';

interface Props {
    filtro: FiltroSopSales;
    home: boolean;
    onChange: () => void;
}

export const SopSalesSalesForecastChart: React.FC<Props> = (props) => {
    const chartRef = useRef<Chart<'bar'>>(null);
    const { mostrarToast } = useToast();
    const { t } = useTranslation();

    const [data, setData] = useState<ChartData<"bar" | "line">>({} as ChartData<"bar" | "line">);
    const [carregando, setCarregando] = useState(true);
    const { usuario } = useAutenticação()

    const [showModal, setShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState<ModeloSopSales>();

    useEffect(() => {
        if (usuario && usuario.cod_usuario) {
            setCarregando(true);
            props.filtro.cod_usuario = usuario.cod_usuario;
            new RepositorioSopSales().getPrevisao(props.filtro).then((res) => {
                const labels: string[] = [];
                const real: (number | null)[] = [];
                const forecastDestaque: (number | null)[] = [];
                const forecast: (number | null)[] = [];
                const budget: (number | null)[] = [];
                const avg_price: (number | null)[] = [];
                const forecastReal: (number | null)[] = [];

                res.forEach((item: any) => {
                    const mes = item.mes || "";

                    labels.push(mes);
                    real.push(item.real);
                    forecast.push(Math.max((item.forecast || 0), (item.num_sales_new || 0)));
                    forecastDestaque.push(props.filtro.value == "Quantity" ? item.num_sales_new : item.forecast);
                    forecastReal.push(item.forecast)

                    budget.push(item.hasOwnProperty('budget') ? item.budget : null);
                    avg_price.push(item.hasOwnProperty('avg_price') ? item.avg_price : null);
                });
                console.log("forecastDestaque", forecastDestaque);
                setData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Actual',
                            data: real,
                            backgroundColor: '#1e88e5',
                            stack: 'stack1',
                        },
                        {
                            label: 'Forecast - Edit',
                            data: forecastDestaque,
                            borderWidth: 0,
                            backgroundColor: 'transparent',
                            pointRadius: 0,
                            type: `line`,
                        },
                        {
                            label: 'Forecast - Real',
                            data: forecastReal,
                            borderWidth: 0,
                            backgroundColor: 'transparent',
                            pointRadius: 0,
                            type: `line`,
                        },
                        {
                            label: 'Forecast',
                            data: forecast,
                            backgroundColor: '#90CAF9',
                            borderColor: '#90CAF9',
                            stack: 'stack2',
                        },
                        {
                            label: 'Budget',
                            type: 'line',
                            data: budget,
                            borderColor: '#9e9e9e',
                            backgroundColor: '#9e9e9e',
                            pointRadius: 0,
                            fill: false,
                            yAxisID: 'y',
                        },
                        {
                            hidden: props.filtro?.value == "Quantity",
                            label: 'Average Price',
                            type: 'line',
                            data: avg_price,
                            borderColor: '#f9a825',
                            backgroundColor: '#f9a825',
                            pointRadius: 3,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y2',
                            segment: {
                                borderDash: ctx => ctx.p0DataIndex >= 3 ? [6, 6] : undefined,
                            },
                        },
                    ],
                });

                setCarregando(false);
            }).catch((error) => {
                mostrarToast({
                    titulo: t("pages.Erro!"),
                    mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                    tipo: "error",
                });
            })
        }

    }, [props.filtro, usuario]);



    const options = () => {
        var aux = optionsChart(props)
        aux.onClick = (evt, elements) => {
            if (!elements.length) return;
            const chart = chartRef.current;
            if (!chart) return;
            const element = elements[0];
            const datasetIndex = element.datasetIndex;
            const index = element.index;
            const dataset = chart.data.datasets[datasetIndex];
            const label = dataset.label;
            const currentValue = dataset.data[index] as number | null;
            // Pegar o valor do dataset "Forecast - Edit"
            const datasetDestaque = chart.data.datasets.find(d => d.label === 'Forecast - Real');
            if (!datasetDestaque) return;
            const currentValueDestaque = datasetDestaque.data[index] as number | null;
            // verificar se a data é  a mesma que a atual com o moment
            const dataAtual = moment().format("MMM/YYYY");

            if (label === 'Forecast' && (chart?.data?.labels?.[index] ?? '').toString() == dataAtual) {
                const auxModelo = new ModeloSopSales();
                auxModelo.des_time = (chart?.data?.labels?.[index] ?? '').toString();
                auxModelo.num_sales_forecast_units = currentValueDestaque || 0;
                auxModelo.num_sales_new = currentValue || 0;
                auxModelo.des_product = auxModelo.des_time;
                setModalInfo(auxModelo);

                setShowModal(true);
            }
        }
        return aux
    };

    const salvarValor = () => {
        props.onChange();
    };



    return (
        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">Sales{!props.home ? " Forecast vs Real & Budget" : ""}</strong>
            {carregando ?
                <SopLoadingAnimation type="CHARTS" />
                :
                <ChartJS id="sales" ref={chartRef} type='bar' options={options()} data={data} plugins={[{ id: 'partialBarHighlight', afterDatasetsDraw: customPlugin }]} />
            }

            <ModalEditForecastValue showModal={showModal} salvarValor={salvarValor}
                filtro={props.filtro}
                linha={modalInfo}
                setShowModal={setShowModal}
            />

        </div>
    );
};

export function optionsChart(props: any) {
    const options: ChartOptions<"bar" | "line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    filter: function (item) {
                        return item.text !== 'Forecast - Edit' && item.text !== "Forecast - Real" && !(props.filtro?.value == "Quantity" && item.text == "Average Price"); // 🔥 oculta só esta legenda
                    }
                }
            },
            title: {
                display: false,
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                filter: function (tooltipItem) {
                    const value = tooltipItem.raw;
                    if (tooltipItem.dataset.label === 'Forecast - Real')
                        return false
                    if (tooltipItem.dataset.label === 'Forecast - Edit') {
                        const datasetIndex = tooltipItem.datasetIndex - 1;
                        const dataset = tooltipItem.chart.data.datasets[datasetIndex];
                        const forecastValue = dataset.data[tooltipItem.dataIndex];
                        return value !== forecastValue && !!value;
                    }

                    return !!value;
                },
                callbacks: {
                    label: function (context: any) {
                        //quando o falor for o do forescat mostrar o valor do forecastReal
                        if (context.dataset.label === 'Forecast') {
                            const datasetIndex = context.datasetIndex - 1;
                            const dataset = context.chart.data.datasets[datasetIndex];
                            //pegar o valor do dataset "Forecast - Real"
                            const datasetForecastRealIndex = context.chart.data.datasets.findIndex((ds: any) => ds.label === 'Forecast - Real');
                            const forecastReal = context.chart.data.datasets[datasetForecastRealIndex].data;
                            const forecastRealValue = forecastReal[context.dataIndex];
                            return `${context.dataset.label}: ${formatarDecimal(forecastRealValue, props.filtro?.value !== "Quantity").replace("R$", "$")}`;
                        }
                        const value = context.parsed.y;
                        return `${context.dataset.label}: ${formatarDecimal(value, props.filtro?.value !== "Quantity").replace("R$", props.filtro?.value !== "Quantity" ? "$" : "")}`;
                    },
                },
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
        },
        scales: {

            y: {
                title: {
                    display: true,
                    text: props.filtro?.value == "Quantity" ? "Quantity" : "R$",
                    font: {
                        size: 12,
                    },
                },
                beginAtZero: false,
                ticks: {
                    callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
                },
            },
            y2: {
                display: props.filtro?.value != "Quantity",
                type: 'linear',
                position: 'right',
                beginAtZero: false,
                ticks: {
                    callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
        },

    };
    return options;

}

export function customPlugin(chart: any) {
    const ctx = chart.ctx;

    const datasetForecastIndex = chart.data.datasets.findIndex((ds: any) => ds.label === 'Forecast');
    const datasetForecastRealIndex = chart.data.datasets.findIndex((ds: any) => ds.label === 'Forecast - Real');
    const datasetForecastDestaqueIndex = chart.data.datasets.findIndex((ds: any) => ds.label === 'Forecast - Edit');
    const datasetBudgetIndex = chart.data.datasets.findIndex((ds: any) => ds.label === 'Budget');

    const datasetForecast = chart.data.datasets[datasetForecastIndex];
    const datasetForecastReal = chart.data.datasets[datasetForecastRealIndex];
    const datasetForecastDestaque = chart.data.datasets[datasetForecastDestaqueIndex];
    const datasetBudget = chart.data.datasets[datasetBudgetIndex];

    const meta = chart.getDatasetMeta(datasetForecastIndex);

    const currentDate = new Date();



    // Existing partial paint logic
    chart.data.labels.forEach((label: string, index: number) => {
        if (datasetForecastDestaque.data[index]) {
            const bar = meta.data[index];
            const total = datasetForecastReal.data[index];
            const paintValue = datasetForecastDestaque.data[index];

            if (!bar || typeof total !== 'number' || !bar.height) return;

            let ratio = 0;
            if (total > paintValue) {
                ratio = Math.min(paintValue / total, 1.0);
            } else {
                ratio = Math.min(total / paintValue, 1.0);
            }

            const fullHeight = bar.base - bar.y;
            const paintHeight = fullHeight * ratio;

            const x = bar.x - bar.width / 2;
            const y = bar.base - paintHeight;

            ctx.fillStyle = '#E19F9E';
            // ctx.fillStyle = total > paintValue ? '#E80E1A' : '#2B7258';
            ctx.fillRect(x, bar.y, bar.width, (fullHeight - paintHeight));
        }
    });


    chart.data.labels.forEach((label: string, index: number) => {
        if (!label) return;

        const forecastValue = datasetForecast.data[index];
        const budgetValue = datasetBudget.data[index];
        const bar = meta.data[index];

        if (!bar || typeof forecastValue !== 'number' || typeof budgetValue !== 'number') return;

        // Convert label (e.g. "May/2025") to Date object
        const [monthStr, yearStr] = label.split('/');
        const month = new Date(Date.parse(monthStr + " 1, 2000")).getMonth();
        const year = parseInt(yearStr);
        const barDate = new Date(year, month);

        if (barDate < new Date(currentDate.getFullYear(), currentDate.getMonth())) return;

        const ratio = forecastValue / budgetValue;
        let arrow = '';
        let color = '';
        //pegar o id do gráfico
        const id = ctx.canvas.id;
        if (id == "production") {
            return;
        }
        color = (id == "sales" || id == "production") ? '#2B7258' : '#E80E1A';
        let color2 = (id == "sales" || id == "production") ? '#E80E1A' : '#2B7258';
        if (ratio > 1.05) {
            arrow = '▲';
            color = color; // red
        } else if (ratio < 0.95) {
            arrow = '▼';
            color = color2; // green
        } else {
            // bolinha
            arrow = '●';
            //cor amarela 
            color = '#FF9800'; // yellow
            // color = '#E19F9E'; // gray
            // return;
        }

        ctx.save();
        ctx.fillStyle = color;
        ctx.font = '16px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(arrow, bar.x, bar.y + 10);
        ctx.restore();
    });
}
